import request from '@/utils/request';

const BASE_URL = '/hwapi';
//  反馈类目
export const getFeedbackConfig = (data) => request({
  url: `${BASE_URL}/homework/feedbackConfig`,
  method: 'post',
  data,
});

export const createFeedback = (data) => request({
  url: `${BASE_URL}/feedback/createFeedback`,
  method: 'post',
  data,
});

// 图片上传
export const uploadFile = (data) => request({
  url: `${BASE_URL}/homework/uploadFile`,
  method: 'post',
  multi: true,
  data,
});
